<template>
  <div class="customerOrderDetailPage">
    <el-tabs
      v-model="activeName"
      type="border-card"
      :before-leave="onBeforeLeave"
    >
      <el-tab-pane
        :label="$l('tab_base_information') || '基本信息'"
        name="base"
      >
        <OrderInfo
          ref="base"
          :orderCode="params.code"
          :disabled="isDisableEditForm"
        />
        <div
          class="d-flex justify-content-end mt-2 mb-2"
          v-if="!isDisableEditForm"
        >
          <el-button type="primary" size="small" @click="save()">{{
            $l('INDEX.btn_save') || '保存'
          }}</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_order_goods') || '产品信息'"
        name="goods"
        lazy
      >
        <OrderGoods :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_demand_fabric') || '产品面料'"
        name="demandFabric"
        lazy
      >
        <DemandFabric :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_tech_doc') || '工艺说明'"
        name="techDoc"
        lazy
      >
        <TechDoc :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_doc') || '订单文件'"
        name="orderDoc"
        lazy
      >
        <OrderDoc :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_demand_material') || '产品辅料'"
        name="demandMabric"
        lazy
      >
        <DemandMaterial
          :orderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_goods_package_size') || '产品包装'"
        name="goodsPackage"
        lazy
      >
        <GoodsPackage :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_demand_package') || '外包装箱'"
        name="demandPackage"
        lazy
      >
        <DemandPackage :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_demand_packing') || '装箱方案'"
        name="demandPacking"
        lazy
      >
        <DemandPacking :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_sample_request') || '样品需求'"
        name="sampleRequest"
        lazy
      >
        <Proofing :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_delivery_batch') || '交货批次'"
        name="batch"
        lazy
      >
        <OrderBatch :orderCode="params.code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_inspection_requirements') || '验货要求'"
        name="checkRequest"
        lazy
      >
        <OrderInspection
          :orderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_execution_log') || '执行日志'"
        name="log"
        lazy
      >
        <OrderExecutionLog
          :orderCode="params.code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OrderInfo from '../../customerorder/components/info'
import OrderGoods from '../../customerorder/components/goods'
import DemandFabric from '../../customerorder/components/demand-fabric'
import TechDoc from '../../customerorder/components/tech-doc'
import OrderDoc from '../../customerorder/components/order-doc'
import DemandMaterial from '../../customerorder/components/demand-material'
import GoodsPackage from '../../customerorder/components/goods-package'
import DemandPackage from '../../customerorder/components/demand-package'
import DemandPacking from '../../customerorder/components/demand-packing'
import Proofing from '../../customerorder/components/proofing'
import OrderBatch from '../../customerorder/components/order-batch'
import OrderInspection from '../../customerorder/components/inspection'
import OrderExecutionLog from '../../customerorder/components/execution-log'
export default {
  name: 'order-customerOrderDetail',
  components: {
    OrderInfo,
    OrderGoods,
    DemandFabric,
    TechDoc,
    OrderDoc,
    DemandMaterial,
    GoodsPackage,
    DemandPackage,
    DemandPacking,
    Proofing,
    OrderBatch,
    OrderInspection,
    OrderExecutionLog
  },
  data() {
    return {
      activeName: 'base'
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    }
  },
  methods: {
    onBeforeLeave(val) {
      if (val === 'base') {
        return true
      }
      if (!this.params.code || this.pageType === 'add') {
        this.$message.warning(
          this.$l('INDEX.tips_save_basicinfo_first') || '请先保存基本信息!'
        )
        return false
      }
    },
    save() {
      this.$refs.base.save()
    }
  }
}
</script>
